import React, { useState } from "react";

type ImgProps = React.DetailedHTMLProps<
  React.ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
> &
  Partial<{
    className: string;
    src: string;
    alt: string;
  }>;

const isFullUrl = (src: string): boolean => {
  try {
    const url = new URL(src);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
};

function ensureStartsWithSlash(word) {
  if (word.startsWith("/")) {
    return word;
  } else {
    return "/" + word;
  }
}

const ImgComponent: React.FC<React.PropsWithChildren<ImgProps>> = ({
  className,
  src = "defaultNoData.png",
  alt = "testImg",
  ...restProps
}) => {
  const [hasError, setHasError] = useState(false);
  const resolvedSrc = isFullUrl(src)
    ? src
    : `${window.location.origin || "http://localhost:3000"}${ensureStartsWithSlash(src)}`;

  return hasError ? (
    <div
      className={`flex items-center justify-center ${className}`}
      style={{ backgroundColor: "#e5e7eb" /* Tailwind's gray-200 */ }}
    >
      {/* Optional: fallback content like "No Image" */}
    </div>
  ) : (
    <img
      className={className}
      src={resolvedSrc}
      alt={alt}
      onError={() => setHasError(true)}
      {...restProps}
      loading="lazy"
    />
  );
};

export { ImgComponent };
